import { useT } from "../../../../i18n/I18nProvider";
import { StatusPill } from "../../../ui";
import { docStatusTone } from "./status";

/**
 * A sales document's status.
 *
 * Still called `StatusBadge` because that is the name four sales screens
 * already import, but it is no longer a shadcn `Badge`: it renders the CRM's
 * own pill, so a status here looks the same as a status on the clients list
 * rather than like a leftover from the previous design.
 */
export function StatusBadge({ status }: { status: string }) {
  const t = useT();
  return <StatusPill tone={docStatusTone(status)}>{t(`sales.status.${status}`)}</StatusPill>;
}
